﻿import {IProjetModel} from "../../Model/Projet/ProjetModel";
import {JsonFetchJson} from "../../Helper/FetchHelper";
import {ResponseApi} from "../../Model/ResponseApi";
import {NotificationHelper} from "../../Helper/NotificationHelper";
import {OnProjetDelete} from "../../Delegates/ProjetDelegate";

export class ProjetDeleteController {
    public static Delete = (model:IProjetModel) => {
        return JsonFetchJson.Delete<ResponseApi<boolean>>(`/projet/${model.Primarykey}`)
            .then(response => {
                if (!response.Data){
                    NotificationHelper.Instance.error("Le projet n'a pas pu être supprimé");
                } else {
                    OnProjetDelete.Fire(model);
                }
                
                return response.Data;
            });
    }
}